const PERMISSION_LIST = {
    PERMISSION: 'permissions',
    ROLEPERMISSION: 'roles_permissions',
    ROLE: 'roles',
    APICONFIGURATION: 'api_configuration',
    SYSTEMCONFIGURATION: 'system_configuration',
    EMAILTEMPLATE: 'email_template',
    SMSTEMPLATE: 'sms_template',
    NOTIFICATIONTEMPLATE: 'notification_template',
    CATEGORY:'category',
    SUBCATEGORY:'subcategory',
    MODEL:'model',
    PRODUCT:'product',
    SALESOFFICE:'sales_office',
    DEALERS:'dealers',
    USERS:'users',
    ORDERS:'orders',
    PRODUCTINQUIRY:'product_inquiry',
    DEALERINQUIRY:'dealer_inquiry',
    STATS:'stats',
    TOPSELLINGPRODUCTS:'top_selling_products',
    TOTALSALES:'total_sales',
    ORDERSTATUS:'order_status',
    TOPDEALERS:'top_dealers',
    REGIONWISESALES:'region_wise_sales',
    STOREWISESALES:'store_wise_sales',
    BULKUPLOADUSERS:'bulk_upload_users',
    BULKUPLOADORDERS:'bulk_upload_orders',
    PAYMENTTREM:'payment_term',
    PLANT:'plant',
    REGION:'region',
    PRODUCTREPORT:'product_report',
    ORDERREPORT:'order_report',
    DEALERREPORT:'dealer_report',
    PRODUCTINQUIRYREPORT:'product_inquiry_report',
    SALESPERFORMANCEREPORT:'sales_performance_report',
    ROLEBASEDDATAACCESS:'role_based_data_access',
    QUERY:'Query',
    PROMOTION:'promotion',
    ZONEWISEREPORT:'zone_wise_report',
    CUSTOMERWISEREPORT:'customer_wise_report',
    PLANTWISEREPORT:'plant_wise_report',
    MTDSALESREPORT:'mtd_sales_report',
    PENDINGORDERREPORT:'pending_order_report',
    TARGET:'target',
    LEDGER:'ledger',
}

const PERMISSION_STATUS = {
    ALLOWED: 1,
    DENY: 0,
}

const PERMISSION_ACTION = {
    FULL: 'full_access',
    VIEW: 'view_permission',
    CREATE: 'create_permission',
    UPDATE: 'edit_permission',
    DELETE: 'delete_permission',
    LIST: 'list_permission',
    UPLOAD: 'upload_permission'
}

export const PERMISSION = {
    PERMISSION_LIST,
    PERMISSION_STATUS,
    PERMISSION_ACTION
}